import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SolicitudCreditoServiceWorkflow } from 'src/app/shared/services/solicitud-credito-workflow.service';
import { AlertService } from '../../_alert/alert.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { RutFormatPipe } from 'src/app/shared/pipes/rutFormat.pipe';
import { MatDialog } from '@angular/material/dialog';
import { MallaSocietariaGraphComponent } from 'src/app/components/malla-societaria-graph/malla-societaria-graph.component';
import * as uuid from 'uuid';
import { ModalEntidadesWorkflowComponent } from '../modal-entidades-workflow/modal-entidades-workflow.component';

interface EntidadUI {
  idEntidad: string; 
  nombre: string;
  expandido: boolean; 

  cabecerasAtributos: any[]; 
  cabecerasServicios: any[];

  ruts: RutUI[];              // Ruts normales
  rutsMalla: RutUI[];        // Ruts derivados de la malla societaria (si aplica) - no siempre tendra datos

  rutsVisibles: RutUI[];
  rutsMallaVisibles: RutUI[];
  
  paginaNormal: number;
  paginaMalla: number;

  ordenColumnaNormal: string;
  ordenAscendenteNormal: boolean;
  
  ordenColumnaMalla: string;
  ordenAscendenteMalla: boolean;

  textoBusquedaNormal?: string;
  textoBusquedaMalla?: string;
}

interface RutUI {
  rut: string;
  filaHabilitada: boolean;
  esMalla: boolean;
  atributosDinamicos: any;
  servicios: ServicioUI[];
  consultadoCompletamente: boolean;
  levelOneRut?: string;       // Indica cual es el rut de nivel 1 del rut actual (se usa para malla)
}

interface ServicioUI {
  idServicio: string;
  nombre: string;
  
  permiteBuscar: boolean; 
  buscarSeleccionado: boolean;
  
  permiteActualizar: boolean;
  actualizarSeleccionado: boolean; 

  estadoConsulta: 'sin_consultar' | 'ok' | 'error' | 'sin_info';
  fechaReporte?: string;
  mensajeError?: string;
}

@Component({
  selector: 'app-consumo-servicios-derivados-workflow',
  templateUrl: './consumo-servicios-derivados-workflow.component.html',
  styleUrls: ['./consumo-servicios-derivados-workflow.component.scss'],
  providers: [RutFormatPipe]
})
export class ConsumoServiciosDerivadosWorkflowComponent implements OnInit {
  @Input() informeNuevo: boolean = false;
  @Input() idTransaccion: string = '';
  @Input() stepper!: number;
  @Input() rut: string = '';
  @Output() operacionNuevo = new EventEmitter<boolean>();

  public bodyModelos: any = {};
  public entidades: any[] = [];
  public contratoEntidades: any[] = [];
  public contratoServicios: any[] = [];
  public modeloVista: EntidadUI[] = [];

  public requestOriginal: any[] = [];

  private razonSocialPrincipal: string = '';
  public graphMallaSocietaria: any[] = [];
  
  constructor(
    private _sessionService: SessionService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private solicitudCreditoService: SolicitudCreditoServiceWorkflow,
    private utilsService: UtilsService,
    private rutFormatPipe: RutFormatPipe,
    public dialog: MatDialog
    ) { }

  ngOnInit(): void {
    this.operacionNuevo.emit(false);
    this.obtenerFlujo();
  }

  // Obtiene el flujo y valida si fue la primera llegada a la vista
  obtenerFlujo() {
    this.spinner.show();
    this.solicitudCreditoService.obtenerFlujo(this.idTransaccion, this.rut).subscribe(resp => {
      this.bodyModelos = resp;
      let pasoAnterior: any;
      resp.stages.forEach((e: any) => {
       if(e.stageID === '4' && Number(e.stageID) != Number(this.stepper + 2)) {
        pasoAnterior = e;
       }
      });
      // Se valida si el paso anterior fue completado y si no se envia al ultimo completado
      if(pasoAnterior && (!pasoAnterior?.completed && pasoAnterior?.optional === false)){
        this.volverEtapa(resp);
      } else {
        this.getEntidadesDerivadas();
      }
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al recuperar datos del flujo de credito');
      this.spinner.hide();
    });
    
  }

  volverEtapa(resp: any): void {
    const pasosCompleted = resp.stages.filter((e: any) => e.completed);
    const cantidad = pasosCompleted.length;
    const ultimoPasoCompletado = Number(pasosCompleted[cantidad - 1].stageID);
    let step = this.solicitudCreditoService.stepsOptions.filter((e: any) => e.stageID == (ultimoPasoCompletado + 1));
    if (!step[0]?.step){
      step = this.solicitudCreditoService.stepsOptions.filter((e: any) => e.stageID == (ultimoPasoCompletado));
    }
    this.alertService.error(`Solicitud de Crédito - Debe completar el paso N° ${Number(step[0]?.step)} para poder continuar`);
    this.solicitudCreditoService.setStep(Number(step[0]?.step));
  }

  getEntidadesDerivadas(): void {
    this.solicitudCreditoService.entidadesDerivadas(this.rut, this.idTransaccion).subscribe(
      resp => {
        const stage5Response = resp?.SolicitudDeCredito?.Stage5Response || null;
        const stage6Response = resp?.SolicitudDeCredito?.Stage6Response || null;
        const stage7Response = resp?.SolicitudDeCredito?.Stage7Response || null;

        this.razonSocialPrincipal = resp?.SolicitudDeCredito?.DatosBasicosSolicitud?.Nombre || '';
        this.entidades = stage5Response?.Entidades || [];
        this.contratoEntidades = stage5Response?.Contrato;

        if(stage5Response?.errors?.hasError === true){
          this.alertService.error(stage5Response?.errors?.details?.message || 'Solicitud de Crédito - Ocurrio un error al obtener las entidades');
        }

        if(this.entidades.length > 0 && this.contratoEntidades.length > 0){
          this.getContratoServicios(stage6Response, stage7Response);
        }
      }, 
      (error) => {
        this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al obtener entidades derivadas');
        this.spinner.hide();
    });
  }

  validateStage7(stage7Response: any): boolean {
    let hasStage7 = false;
    if (stage7Response && Object.keys(stage7Response).length > 0) {
      const tieneRequestValido = Array.isArray(stage7Response?.request) && stage7Response?.request.length > 0;
      const tieneDatosReales = Object.keys(stage7Response).some(key => key !== 'request');
      hasStage7 = tieneRequestValido && tieneDatosReales;
    }
    return hasStage7;
  }

  getContratoServicios(stage6Response: any, stage7Response: any): void {
    if(stage6Response?.errors?.hassError === true){
      this.alertService.error(stage6Response?.errors?.details?.message || 'Solicitud de Crédito - Ocurrio un error al obtener los servicios disponibles');
    }
    const hasStage7: boolean = this.validateStage7(stage7Response);

    if(stage6Response?.ContratoServicios?.length > 0) { // si esta el contrato en el response se maneja aqui sino se va a buscar por api
      this.contratoServicios = stage6Response?.ContratoServicios;
      this.generateModeloVista(hasStage7); 
      if(hasStage7){
        this.mapeosStage7(stage7Response);
      } else {
        this.spinner.hide();
      }
    } else {
      this.getContratoServiciosApi(hasStage7);
    }
  }

  mapeosStage7(stage7Response: any): void {
    this.requestOriginal = (JSON.parse(JSON.stringify(stage7Response?.request)) || []);
    this.addRutsMalla(stage7Response);
    this.setEstadosConsulta(stage7Response);
    this.setGraphMalla(stage7Response);
    this.spinner.hide();
  }

  addRutsMalla(stage7Response: any): void {
    if (!this.modeloVista || this.modeloVista.length <= 0) return;

    for (const entidad of this.modeloVista) {
      const entidadResponse = stage7Response?.[entidad?.idEntidad];
      if (!entidadResponse || Object.keys(entidadResponse).length <= 0) continue;

      const contratoEntidad = this.contratoEntidades?.find((e: any) => e?.key === entidad?.idEntidad);

      const rutsProcesadosMalla = new Set<string>(entidad.rutsMalla?.map(r => r?.rut) || []);

      for (const titular of entidad?.ruts) {
        
        const mallaTitular = entidadResponse[titular.rut]?.mallaSocietaria?.content;
        if (!mallaTitular) continue;

        const nivel2 = [...(mallaTitular?.socios || []), ...(mallaTitular?.participaciones || [])];

        for (const personaN2 of nivel2) {
          const rutN2 = personaN2?.rut;

          if (!rutN2 || rutN2 === '') continue;
          if (entidad.ruts.some(r => r?.rut === rutN2)) continue;
          if (rutsProcesadosMalla.has(rutN2)) continue;

          rutsProcesadosMalla.add(rutN2);
          entidad.rutsMalla.push(this.crearObjetoRutMalla(rutN2, personaN2?.nombre, titular?.rut, contratoEntidad));

          const mallaN2 = entidadResponse[rutN2]?.mallaSocietaria?.content;
          if (mallaN2) {
            const nivel3 = [...(mallaN2?.socios || []), ...(mallaN2?.participaciones || [])];
            
            for (const personaN3 of nivel3) {
              const rutN3 = personaN3?.rut;

              if (!rutN3 || rutN3 === '') continue;
              if (entidad.ruts.some(r => r.rut === rutN3)) continue;
              if (rutsProcesadosMalla.has(rutN3)) continue;

              rutsProcesadosMalla.add(rutN3);
              entidad.rutsMalla.push(this.crearObjetoRutMalla(rutN3, personaN3?.nombre, rutN2, contratoEntidad));
            }
          }
        }
      }

      entidad.rutsMallaVisibles = [...entidad.rutsMalla];
    }
  }

  crearObjetoRutMalla(rut: string, nombre: string, parentRut: string, contratoEntidad: any): RutUI {
    const atributosFalsosApi = [
      { name: 'nombre', value: nombre || '' }
    ];

    return {
      rut: rut,
      filaHabilitada: false,
      esMalla: true,
      levelOneRut: parentRut,
      atributosDinamicos: this.getAtributosRut(atributosFalsosApi, contratoEntidad),
      servicios: this.getServiciosRut(),
      consultadoCompletamente: false
    };
  }

  getContratoServiciosApi(hasStage7: boolean): void {
    this.solicitudCreditoService.serviciosDisponibles(this.rut, this.idTransaccion, false).subscribe(resp => {
      this.contratoServicios = resp?.SolicitudDeCredito?.Stage6Response?.ContratoServicios;
      this.generateModeloVista(hasStage7);
      if(resp?.SolicitudDeCredito?.Stage6Response?.errors?.hassError === true){
        this.alertService.error(resp?.SolicitudDeCredito?.Stage6Response?.errors?.details?.message || 'Solicitud de Crédito - Ocurrio un error al obtener los servicios disponibles');
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al obtener servicios disponibles');
      this.spinner.hide();
    });
  }

  setGraphMalla(stage7Response: any): void {
    this.graphMallaSocietaria = [];
    if (!this.validateStage7(stage7Response)) return;

    let tieneMallaValida = false;

    for (const entidadKey of Object.keys(stage7Response)) {
      const respuestaEntidad = stage7Response?.[entidadKey];
      if (!respuestaEntidad) continue;

      for (const rutKey of Object.keys(respuestaEntidad)) {
        const contentMalla = respuestaEntidad?.[rutKey]?.mallaSocietaria?.content;
        
        if (contentMalla) {
          const tieneSocios = contentMalla?.socios && contentMalla?.socios.length > 0;
          const tieneParticipaciones = contentMalla?.participaciones && contentMalla?.participaciones.length > 0;

          if (tieneSocios || tieneParticipaciones) {
            tieneMallaValida = true;
            break;
          }
        }
      }
      if (tieneMallaValida) break;
    }

    if (!tieneMallaValida) {
      return; 
    }

    const arrayMalla: any[] = [];
    const idPrincipal = uuid.v4();

    const nodoPrincipal = this.utilsService.getElementMalla(
      idPrincipal, null, false, 'Principal', 
      this.razonSocialPrincipal || 'Principal', 
      this.rutFormatPipe.transform(this.rut)
    );
    nodoPrincipal.rut = this.rut;
    arrayMalla.push(nodoPrincipal);

    const clasesHTML = ['bg-entidad-0', 'bg-entidad-1', 'bg-entidad-2', 'bg-entidad-3', 'bg-entidad-4'];
    const clasesRutHTML = ['bg-rut-entidad-0', 'bg-rut-entidad-1', 'bg-rut-entidad-2', 'bg-rut-entidad-3', 'bg-rut-entidad-4'];

    for (const [index, entidad] of this.entidades.entries()) {

      if (!entidad?.items || entidad?.items.length === 0) continue;
      
      const idGraphEntidad = uuid.v4();
      const claseColor = clasesHTML[index % clasesHTML.length];
      const claseColorRut = clasesRutHTML[index % clasesRutHTML.length];

      const nombreEntidad = this.contratoEntidades.find(e => e.key == entidad?.entidad);
      
      arrayMalla.push(this.utilsService.getElementMalla(
        idGraphEntidad, idPrincipal, true, 'Entidad', 
        (nombreEntidad?.name || entidad?.entidad), '', undefined, undefined, undefined, claseColor
      ));

      const respuestaEntidad = stage7Response[entidad?.entidad] || {};

      for (const element1 of entidad?.items) {
        const idGraphTitular = element1?.idGraph || uuid.v4(); 
        const nombreTitular = element1?.atributos?.find((a:any) => a?.name == 'nombre' || a?.name == 'Nombre')?.value || '';

        const nodoTitular = this.utilsService.getElementMalla(
          idGraphTitular, idGraphEntidad, true, (nombreEntidad?.name || entidad?.entidad), 
          nombreTitular, this.rutFormatPipe.transform(element1?.rut), 
          entidad.entidad, 'rutDerivado', 
          '', //`checkboxfila-${element1.rut}-${entidad.entidad}`, // id-table
          claseColorRut
        );
        nodoTitular.rut = element1?.rut;
        arrayMalla.push(nodoTitular);

        const mallaTitular = respuestaEntidad?.[element1?.rut]?.mallaSocietaria?.content;
        if (!mallaTitular) continue;

        const ramasN2 = [
          { lista: mallaTitular?.socios || [], tipo: 'Socio' },
          { lista: mallaTitular?.participaciones || [], tipo: 'Sociedad' }
        ];

        for (const ramaN2 of ramasN2) {
          for (const personaN2 of ramaN2.lista) {
            if (!personaN2.rut) continue;

            const idGraphN2 = uuid.v4();
            const nodoN2 = this.utilsService.getElementMalla(
              idGraphN2, idGraphTitular, true, ramaN2.tipo, 
              personaN2?.nombre || '', this.rutFormatPipe.transform(personaN2?.rut), 
              entidad?.entidad, 'rutMalla', 
              '' //`checkboxfila-${personaN2.rut}-${entidad.entidad}-entidadMalla` // id-table
            );
            nodoN2.rut = personaN2?.rut;
            arrayMalla.push(nodoN2);

            const mallaN2 = respuestaEntidad?.[personaN2?.rut]?.mallaSocietaria?.content;
            if (!mallaN2) continue;

            const ramasN3 = [
              { lista: mallaN2?.socios || [], tipo: 'Socio' },
              { lista: mallaN2?.participaciones || [], tipo: 'Sociedad' }
            ];

            for (const ramaN3 of ramasN3) {
              for (const personaN3 of ramaN3.lista) {
                if (!personaN3.rut) continue;

                const idGraphN3 = uuid.v4();
                const nodoN3 = this.utilsService.getElementMalla(
                  idGraphN3, idGraphN2, true, ramaN3.tipo, 
                  personaN3?.nombre || '', this.rutFormatPipe.transform(personaN3?.rut), 
                  entidad?.entidad, 'rutMalla', 
                  '' //`checkboxfila-${personaN3.rut}-${entidad.entidad}-entidadMalla` // id-table
                );
                nodoN3.rut = personaN3?.rut;
                arrayMalla.push(nodoN3);
              }
            }
          }
        }
      }
    }

    this.graphMallaSocietaria = arrayMalla;
  }

  isNumber(val: any): boolean { return typeof val === 'number'; }

  preConsultaValida(): boolean {
    let count = 0;

    for (const entidad of this.entidades) {
      const contratoEntidad = this.contratoEntidades.find((elemento: any) => elemento?.key == entidad?.entidad);
      if (!contratoEntidad) continue;

      if (entidad?.items && entidad?.items.length > 0) {
        const elements = entidad?.items.filter((e: any) => e?.preConsulta && e.preConsulta.length > 0);
        count += elements.length;
      }
    }

    return count > 0 && count <= 10;
  }

  generateModeloVista(hasStage7: boolean): void {
    this.modeloVista = [];

    if(!this.entidades || this.entidades.length <= 0) {
      console.error("Error al obtener las entidades");
      return;
    }

    if(!this.contratoEntidades || this.contratoEntidades.length <= 0) {
      console.error("Error al obtener el contrato de entidades");
      return;
    }

    const hasPreConsultaValida: boolean = !hasStage7 ? this.preConsultaValida() : false; // se valida si la preconsulta definida es valida

    const serviciosVisibles = this.contratoServicios
    .filter(s => s.display === true)
    .map(s => ({
      idServicio: s.key,
      nombre: s.name,
      permiteBuscar: this.getServiceType('buscarHistorico', s.values),
      permiteActualizar: this.getServiceType('crear', s.values),
    }));

    let count = 0;
    for(const entidad of this.entidades) {
      const contratoEntidad = this.contratoEntidades.find((elemento: any) => elemento.key == entidad.entidad);
      if(!contratoEntidad) {
        continue;
      }

      const cabecerasFiltradas = contratoEntidad.outputVars
      .filter((v: any) => v.name !== 'rut' && v.name !== 'Rut' && v.display !== false)
      .map((v: any) => ({
        key: v.name,
        nombre: v.displayName || v.name
      }));
      
      const nuevaEntidad: EntidadUI = {
        idEntidad: entidad.entidad,
        nombre: contratoEntidad?.name || entidad.entidad,
        expandido: count == 0 ? true: false,
        cabecerasAtributos: cabecerasFiltradas,
        cabecerasServicios: serviciosVisibles,
        ruts: [],
        rutsMalla: [],
        rutsVisibles: [],
        rutsMallaVisibles: [],
        paginaNormal: 1,
        paginaMalla: 1,
        ordenColumnaNormal: '',
        ordenAscendenteNormal: true,
        ordenColumnaMalla: '',
        ordenAscendenteMalla: true,
        textoBusquedaNormal: '',
        textoBusquedaMalla: ''
      }

      const rutsProcesados = new Set<string>(); 

      if(entidad?.items && entidad?.items.length > 0) {
        for(const itemRut of entidad?.items) {
          const rutString = itemRut?.rut || '';
          
          // no debe estar duplicado
          if (rutString === '' || rutsProcesados.has(rutString)) {
            continue; 
          }
          
          // se valida que este rut tenga pre consulta definida
          const hasPreconsulta: boolean = hasPreConsultaValida && itemRut?.preConsulta && itemRut?.preConsulta.length > 0;
          
          rutsProcesados.add(rutString);

          const elementRut: RutUI = {
            rut: rutString,
            filaHabilitada: hasPreconsulta ? true : false,
            esMalla: false,
            atributosDinamicos: this.getAtributosRut(itemRut?.atributos, contratoEntidad),
            servicios: this.getServiciosRut(hasPreconsulta ? itemRut?.preConsulta : []),
            consultadoCompletamente: false
          }

          nuevaEntidad.ruts.push(elementRut);
        }
      }
      nuevaEntidad.rutsVisibles = [...nuevaEntidad.ruts];
      this.modeloVista.push(nuevaEntidad);
      count++;
    }

    if (hasPreConsultaValida) {
      setTimeout(() => {
        this.ejecutarConsultaAutomatica();
      }, 0);
    }
  }

  getServiciosRut(serviciosPreConsulta: {key: string, type: string}[] = []): ServicioUI[] {
    if(!this.contratoServicios || this.contratoServicios.length <= 0) {
      return [];
    }

    const serviciosResponse: ServicioUI[] = [];
    for(const elementServicio of this.contratoServicios) {
      if(elementServicio && elementServicio?.display == true) {
        const permiteBuscar = this.getServiceType('buscarHistorico', elementServicio?.values);
        const permiteActualizar = this.getServiceType('crear', elementServicio?.values);
        
        const typeAutoConsulta = serviciosPreConsulta.find(e => e.key == elementServicio?.key)?.type || '';

        const servicio: ServicioUI = {
          idServicio: elementServicio?.key,
          nombre: elementServicio?.name,
          permiteBuscar: permiteBuscar,
          buscarSeleccionado: typeAutoConsulta == 'buscarHistorico' && permiteBuscar ? true : false,
          permiteActualizar: permiteActualizar,
          actualizarSeleccionado: typeAutoConsulta == 'crear' && permiteActualizar ? true : false,
          estadoConsulta: 'sin_consultar',
          fechaReporte: '',
          mensajeError: ''
        }

        serviciosResponse.push(servicio);
      }
    }

    return serviciosResponse || [];
  }

  getServiceType(type: string, servicios: any[]): boolean {
    if(!type || !servicios || servicios.length <= 0) {
      return false;
    }
    return servicios.some(e => e?.type === type);
  }

  getAtributosRut(atributos: any[], contratoEntidad: any): any[] {
    if(!contratoEntidad?.outputVars || contratoEntidad?.outputVars.length <= 0) {
      return [];
    }

    const atributosSeguros = atributos || [];
    const atributosResponse: any[] = [];

    for (const outputVar of contratoEntidad.outputVars) {
      if (outputVar.display === false || outputVar.name === 'rut' || outputVar.name === 'Rut') {
        continue;
      }

      const atributoApi = atributosSeguros.find((elemento: any) => elemento.name === outputVar.name);

      atributosResponse.push({
        ...outputVar,
        value: atributoApi?.value || "" 
      });
    }

    return atributosResponse;
  }

  buscarTodosEntidad(rutsLista: RutUI[], seleccionar: boolean): void {
    rutsLista.forEach(rut => {
      if (rut.filaHabilitada) {
        if(rut?.servicios && rut?.servicios.length > 0) {
          rut.servicios.forEach(servicio => {
            if (servicio.permiteBuscar) {
              servicio.buscarSeleccionado = seleccionar;
              if (seleccionar) {
                servicio.actualizarSeleccionado = false;
              }
            }
          });
        }
      }
    });
  }

  actualizarTodosEntidad(rutsLista: RutUI[], seleccionar: boolean): void {
    rutsLista.forEach(rut => {
      if (rut.filaHabilitada) {
        if(rut?.servicios && rut?.servicios.length > 0) {
          rut.servicios.forEach(servicio => {
            if (servicio.permiteActualizar) {
              servicio.actualizarSeleccionado = seleccionar;
              if (seleccionar) {
                servicio.buscarSeleccionado = false;
              }
            }
          });
        }
      }
    });
  }

  habilitarTodosEntidad(rutsOriginales: RutUI[], rutsVisibles: RutUI[], seleccionar: boolean): void { 
    let totalHabilitados = rutsOriginales.filter(r => r.filaHabilitada).length;

    for (const rut of rutsVisibles) {
      if (seleccionar) {
        if (rut.filaHabilitada) {
          continue;
        }

        if (totalHabilitados >= 10) {
          break; 
        }

        rut.filaHabilitada = true;
        totalHabilitados++; 
        
      } else {
        rut.filaHabilitada = false;
        
        if (rut?.servicios && rut?.servicios.length > 0) {
          rut.servicios.forEach(servicio => {
            servicio.actualizarSeleccionado = false;
            servicio.buscarSeleccionado = false;
          });
        }
      }
    }
  }

  toggleFilaIndividual(rut: RutUI, rutsLista: RutUI[], habilitar: boolean): void {
    if (habilitar) {
      const totalHabilitados = rutsLista.filter(r => r.filaHabilitada).length;
      
      if (totalHabilitados < 11) {
        rut.filaHabilitada = true;
      } else {
        this.alertService.error('Máximo 10 ruts por consulta.');
        setTimeout(() => rut.filaHabilitada = false, 0);
      }
    } else {
      rut.filaHabilitada = false;
      rut.servicios.forEach(s => {
        s.buscarSeleccionado = false;
        s.actualizarSeleccionado = false;
      });
    }
  }

  toggleServicioIndividual(rut: RutUI, servicio: ServicioUI, tipo: 'actualizar' | 'buscar', seleccionar: boolean): void {
    if (seleccionar) {
      if (!rut.filaHabilitada) {
        this.alertService.error('Debe habilitar el rut para seleccionar el servicio.');
        setTimeout(() => tipo === 'buscar' ? servicio.buscarSeleccionado = false : servicio.actualizarSeleccionado = false, 0);
        return;
      }

      if (tipo === 'buscar') {
        servicio.buscarSeleccionado = true;
        servicio.actualizarSeleccionado = false;
      } else {
        servicio.actualizarSeleccionado = true;
        servicio.buscarSeleccionado = false;
      }

    } else {
      if (tipo === 'buscar') {
        servicio.buscarSeleccionado = false;
      } else {
        servicio.actualizarSeleccionado = false;
      }
    }

  }

  buscarTodosPorServicio(rutsLista: RutUI[], idServicio: string, seleccionar: boolean): void {
    rutsLista.forEach(rut => {
      if (rut.filaHabilitada) {
        const servicio = rut.servicios.find(s => s.idServicio === idServicio);
        
        if (servicio && servicio.permiteBuscar) {
          servicio.buscarSeleccionado = seleccionar;
          
          if (seleccionar) {
            servicio.actualizarSeleccionado = false;
          }
        }
      }
    });
  }

  actualizarTodosPorServicio(rutsLista: RutUI[], idServicio: string, seleccionar: boolean): void {
    rutsLista.forEach(rut => {
      if (rut.filaHabilitada) {
        const servicio = rut.servicios.find(s => s.idServicio === idServicio);
        
        if (servicio && servicio.permiteActualizar) {
          servicio.actualizarSeleccionado = seleccionar;
          
          if (seleccionar) {
            servicio.buscarSeleccionado = false;
          }
        }
      }
    });
  }

  validarEveryConsulta(servicios: ServicioUI[]): boolean {
    if(!servicios || servicios.length <= 0)
      return false;

    return servicios.every(e => e.estadoConsulta != 'sin_consultar');
  }

  ordenarTabla(entidad: EntidadUI, columnaDinamica: string, isMalla: boolean): void {
    const columnaActual = isMalla ? entidad.ordenColumnaMalla : entidad.ordenColumnaNormal;
    let ascendente = isMalla ? entidad.ordenAscendenteMalla : entidad.ordenAscendenteNormal;

    if (columnaActual === columnaDinamica) {
      ascendente = !ascendente;
    } else {
      ascendente = true;
    }

    if (isMalla) {
      entidad.ordenColumnaMalla = columnaDinamica;
      entidad.ordenAscendenteMalla = ascendente;
    } else {
      entidad.ordenColumnaNormal = columnaDinamica;
      entidad.ordenAscendenteNormal = ascendente;
    }

    const listaAOrdenar = isMalla ? entidad.rutsMalla : entidad.ruts;

    listaAOrdenar.sort((a, b) => {
      let valorA: any = '';
      let valorB: any = '';

      if (columnaDinamica === 'rut') {
        valorA = a.rut;
        valorB = b.rut;
      } else {
        const attrA = a.atributosDinamicos.find((attr: any) => attr.name === columnaDinamica);
        const attrB = b.atributosDinamicos.find((attr: any) => attr.name === columnaDinamica);
        valorA = attrA ? attrA.value : '';
        valorB = attrB ? attrB.value : '';
      }

      const numA = Number(valorA);
      const numB = Number(valorB);
      if (valorA !== '' && valorB !== '' && !isNaN(numA) && !isNaN(numB)) {
        return ascendente ? numA - numB : numB - numA;
      }

      const strA = String(valorA).toLowerCase();
      const strB = String(valorB).toLowerCase();

      if (strA < strB) return ascendente ? -1 : 1;
      if (strA > strB) return ascendente ? 1 : -1;
      return 0;
    });

    if (isMalla) {
      entidad.paginaMalla = 1;
    } else {
      entidad.paginaNormal = 1;
    }

    this.filtrarRutsBuscador(entidad, isMalla);
  }

  ejecutarConsultaAutomatica(): void {
    if (!this.modeloVista || this.modeloVista.length <= 0) return;

    const requestMasivo: any[] = [];
    for (const entidad of this.modeloVista) {
      if(!entidad?.ruts || entidad?.ruts.length <= 0) {
        continue;
      }
      const rutsAConsultar = entidad?.ruts.filter(e => e?.filaHabilitada && e.servicios.some(s => s?.actualizarSeleccionado || s?.buscarSeleccionado));
      if (rutsAConsultar.length > 0) {
        
        const itemsPayload = rutsAConsultar.map(rutObj => {
          const serviciosActivos = rutObj?.servicios
            .filter(s => s?.buscarSeleccionado || s?.actualizarSeleccionado)
            .map(s => {
              const contratoServicio = this.contratoServicios.find(cs => cs?.key === s?.idServicio);
              const tipoAccionBuscada = s?.buscarSeleccionado ? 'buscarHistorico' : 'crear'; 
              const valueOriginal = contratoServicio?.values?.find((v: any) => v?.type === tipoAccionBuscada) || {};

              if (!valueOriginal || Object.keys(valueOriginal).length <= 0) {
                const payload = {
                  key: s?.idServicio,
                  values: []
                }
                return payload;
              }

              const servicio = JSON.parse(JSON.stringify(valueOriginal));

              if (servicio?.inputVars && servicio?.inputVars.length > 0) {
                servicio.inputVars.forEach((inputVar: any) => {
                  
                  if (inputVar?.key === 'rut' || inputVar?.key === 'Rut') {
                    inputVar.value = rutObj?.rut;
                  } 
                  else if (inputVar?.key === 'idOrganizacion') {
                    inputVar.value = this._sessionService.getOrganization();
                  } 
                  else if (inputVar?.key === 'idUsuario') {
                    inputVar.value = this._sessionService.getUserInfo().username;
                  } 
                  else if (inputVar?.key === 'requestOrigin') {
                    inputVar.value = 'WEB';
                  }
                });
              }

              const payload = {
                key: s?.idServicio,
                values: [servicio]
              }

              return payload;
            });

          const objetoRutApi: any = {
            rut: rutObj.rut,
            servicioAConsultar: serviciosActivos
          };
          if (rutObj.levelOneRut) {
            objetoRutApi.levelOneRut = rutObj.levelOneRut;
          }

          return objetoRutApi;
        });

        requestMasivo.push({
          entidad: entidad?.idEntidad,
          items: itemsPayload
        });
      }
    }

    if (requestMasivo.length > 0) {
      this.spinner.show();
      this.solicitudCreditoService.consultarServiciosDerivados(this.rut, this.idTransaccion, requestMasivo).subscribe(resp => {
        if(this.validateStage7(resp?.SolicitudDeCredito?.Stage7Response)){
          this.mapeosStage7(resp?.SolicitudDeCredito?.Stage7Response);
          requestMasivo.forEach((req: any) => {
            this.limpiarSeleccionados(req.entidad, req.items);
          });
        } else {
          this.alertService.error('Solicitud de Crédito - Ocurrio un error al recuperar los datos de los reportes');
        }
        this.spinner.hide();
      }, (error: any) => {
        this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al consultar servicios');
        this.spinner.hide();
      });
    }

  }

  consultar(entidadId: string, rutsLista: RutUI[]): void {
    if(!entidadId) {console.error('No se logró identificar la entidad'); return;}
    if(!rutsLista || rutsLista.length <= 0) {console.error('No se logró obtener el listado de ruts'); return;}

    const rutsAConsultar = rutsLista.filter(e => e.filaHabilitada && e.servicios.some(s => s.actualizarSeleccionado || s.buscarSeleccionado));
    if(!rutsAConsultar || rutsAConsultar.length <= 0) {
      this.alertService.error("Debe seleccionar por lo menos un rut y un servicio a consultar.");
      return;
    }

    const itemsPayload = rutsAConsultar.map(rutObj => {
      
      const serviciosActivos = rutObj.servicios
        .filter(s => s?.buscarSeleccionado || s?.actualizarSeleccionado)
        .map(s => {
          const contratoServicio = this.contratoServicios.find(cs => cs?.key === s?.idServicio);
          const tipoAccionBuscada = s?.buscarSeleccionado ? 'buscarHistorico' : 'crear'; 
          const valueOriginal = contratoServicio?.values?.find((v: any) => v?.type === tipoAccionBuscada) || {};

          if (!valueOriginal || Object.keys(valueOriginal).length <= 0) {
            const payload = {
              key: s?.idServicio,
              values: []
            }
            return payload;
          }

          const servicio = JSON.parse(JSON.stringify(valueOriginal));

          if (servicio?.inputVars && servicio?.inputVars.length > 0) {
            servicio.inputVars.forEach((inputVar: any) => {
              
              if (inputVar?.key === 'rut' || inputVar?.key === 'Rut') {
                inputVar.value = rutObj?.rut;
              } 
              else if (inputVar?.key === 'idOrganizacion') {
                inputVar.value = this._sessionService.getOrganization();
              } 
              else if (inputVar?.key === 'idUsuario') {
                inputVar.value = this._sessionService.getUserInfo().username;
              } 
              else if (inputVar?.key === 'requestOrigin') {
                inputVar.value = 'WEB';
              }
            });
          }

          const payload = {
            key: s?.idServicio,
            values: [servicio]
          }

          return payload; 
        });

      const objetoRutApi: any = {
        rut: rutObj.rut,
        servicioAConsultar: serviciosActivos
      };

      if (rutObj.levelOneRut) {
        objetoRutApi.levelOneRut = rutObj.levelOneRut;
      }

      return objetoRutApi;
    });

    const requestFinal = [{
      entidad: entidadId,
      items: itemsPayload
    }];

    if(itemsPayload && itemsPayload.length > 0){
      this.spinner.show();
      this.solicitudCreditoService.consultarServiciosDerivados(this.rut, this.idTransaccion, requestFinal).subscribe(resp => {
        if(this.validateStage7(resp?.SolicitudDeCredito?.Stage7Response)){
          this.mapeosStage7(resp?.SolicitudDeCredito?.Stage7Response);
          this.limpiarSeleccionados(entidadId, itemsPayload);
        } else {
          this.alertService.error('Solicitud de Crédito - Ocurrio un error al recuperar los datos de los reportes');
        }
        this.spinner.hide();
      }, (error: any) => {
        this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al consultar servicios');
        this.spinner.hide();
      });
    } else {
      this.alertService.error('Solicitud de Crédito - No se encuentran servicios seleccionados');
      this.spinner.hide();
    }

  }

  limpiarSeleccionados(entidadId: string, ruts: any[]): void {
    if(!entidadId) return;
    if(!ruts || ruts.length <= 0) return;

    const entidadElement = this.modeloVista.find(e => e.idEntidad == entidadId);
    if(!entidadElement) return;

    for(const rutRequest of ruts) {
      if(!rutRequest?.servicioAConsultar || rutRequest.servicioAConsultar.length <= 0) continue;

      const rutElement = entidadElement.ruts.find(e => e?.rut == rutRequest?.rut);
      if(rutElement) {
        rutElement.filaHabilitada = false;
        if(!rutElement?.servicios || rutElement.servicios.length <= 0) continue;
        for(const servicio of rutElement.servicios) {
          servicio.actualizarSeleccionado = false;
          servicio.buscarSeleccionado = false;
        }
        continue;
      }

      const rutElementMalla = entidadElement.rutsMalla.find(e => e?.rut == rutRequest?.rut);
      if(rutElementMalla) {
        rutElementMalla.filaHabilitada = false;
        if(!rutElementMalla?.servicios || rutElementMalla.servicios.length <= 0) continue;
        for(const servicio of rutElementMalla.servicios) {
          servicio.actualizarSeleccionado = false;
          servicio.buscarSeleccionado = false;
        }
        continue;
      }
    }
  }

  setEstadosConsulta(stage7Response: any): void {
    if(!this.modeloVista || this.modeloVista.length <= 0) return;
    if(!this.validateStage7(stage7Response)) return;

    const entidadesConsultadas = this.modeloVista.filter(e => e?.idEntidad && stage7Response?.[e.idEntidad]);
    if(!entidadesConsultadas || entidadesConsultadas.length <= 0) return;

    for (const entidad of entidadesConsultadas) {
      const respuestaEntidad = stage7Response[entidad.idEntidad];
      const todosLosRuts = [...entidad.ruts, ...(entidad.rutsMalla || [])];

      for (const rutObj of todosLosRuts) {
        const respuestaRut = respuestaEntidad[rutObj.rut];

        if (respuestaRut) {
          for (const servicio of rutObj.servicios) {
            const respuestaServicio = respuestaRut[servicio.idServicio];

            if (respuestaServicio) {
              const hasError = respuestaServicio.errors?.hassError === true;
              const fechaRaw = respuestaServicio.fechaReporte;
              const sinInfo = !fechaRaw || fechaRaw === 'Sin Información';

              if (hasError) {
                servicio.estadoConsulta = 'error';
                servicio.mensajeError = respuestaServicio.errors?.details?.message || 'Ocurrió un Error';
              } 
              else if (sinInfo) {
                servicio.estadoConsulta = 'sin_info';
                servicio.mensajeError = 'Sin información histórica disponible';
              } 
              else {
                servicio.estadoConsulta = 'ok';
                servicio.fechaReporte = this.obtieneFecha(fechaRaw); 
              }

              //servicio.buscarSeleccionado = false;
              //servicio.actualizarSeleccionado = false;
            }
          }
          rutObj.consultadoCompletamente = rutObj.servicios.every(s => s.estadoConsulta !== 'sin_consultar');
          //rutObj.filaHabilitada = false;
        }
      }
    }
  }

  borrarServicio(entidad: string, rutEntidad: string, servicio: string): void {
    if(!entidad || !rutEntidad || !servicio) { console.error("Dato de entrada faltante"); return;}

    const entidadesReporte: any[] = [
      {
        key: entidad,
        items: [
          {
            rut: rutEntidad,
            services: [
              servicio
            ]
          }
        ]
      }
    ];

    this.spinner.show();
    this.solicitudCreditoService.borrarReportesDerivados(this.rut, this.idTransaccion, entidadesReporte).subscribe(resp => {
      if(this.validateStage7(resp?.SolicitudDeCredito?.Stage7Response)){
        this.resetearEstadoServicioUI(entidad, rutEntidad, servicio);
        this.mapeosStage7(resp?.SolicitudDeCredito?.Stage7Response);
      } else {
        this.alertService.error('Solicitud de Crédito - Ocurrio un error al recuperar los datos de los reportes');
      }
      this.spinner.hide();
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al consultar el servicio de borrado');
      this.spinner.hide();
    });
  }

  resetearEstadoServicioUI(entidadId: string, rut: string, servicioId: string): void {
    if (!this.modeloVista || this.modeloVista.length <= 0) return;

    const entidadObj = this.modeloVista.find(e => e?.idEntidad === entidadId);
    if (!entidadObj) return;

    const todosLosRuts = [...(entidadObj?.ruts || []), ...(entidadObj?.rutsMalla || [])];
    const rutObj = todosLosRuts.find(r => r?.rut === rut);
    if (!rutObj) return;

    const servicioObj = rutObj?.servicios.find(s => s?.idServicio === servicioId);
    if (servicioObj) {
      servicioObj.estadoConsulta = 'sin_consultar';
      servicioObj.fechaReporte = undefined;
      servicioObj.mensajeError = undefined;
      servicioObj.buscarSeleccionado = false;
      servicioObj.actualizarSeleccionado = false;
    }

    rutObj.consultadoCompletamente = rutObj.servicios.every(s => s?.estadoConsulta !== 'sin_consultar');
  }

  reconsultar(entidadId: string, rut: string, servicioId: string): void{
    if(!entidadId || !rut || !servicioId) return;

    const entidad = this.requestOriginal.find((e: any) => e?.entidad == entidadId);
    if(!entidad || !entidad?.items || entidad?.items.length <= 0) return;

    const rutElement = entidad?.items.find((e: any) => e?.rut == rut);
    if(!rutElement || !rutElement?.servicioAConsultar || rutElement?.servicioAConsultar.length <= 0) return;

    const serviceElement = rutElement?.servicioAConsultar.find((e: any) => e?.key == servicioId);
    if(!serviceElement) return;

    const requestReconsulta = [
      {
        entidad: entidadId,
        items: [
          {
            rut: rut,
            servicioAConsultar: [
              serviceElement
            ]
          }
        ]
      }
    ];

    this.spinner.show();
    this.solicitudCreditoService.consultarServiciosDerivados(this.rut, this.idTransaccion, requestReconsulta).subscribe(resp => {
      if(this.validateStage7(resp?.SolicitudDeCredito?.Stage7Response)){
        this.mapeosStage7(resp?.SolicitudDeCredito?.Stage7Response);
      } else {
        this.alertService.error('Solicitud de Crédito - Ocurrio un error al recuperar los datos de los reportes');
      }
      this.spinner.hide();
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al consultar servicio de reportes');
      this.spinner.hide();
    });
  }

  limpiarEntidad(entidadId: string): void {
    if(!this.modeloVista || this.modeloVista.length <= 0) return;

    const entidad = this.modeloVista.find(e => e?.idEntidad == entidadId);
    if(!entidad) return;

    const ruts = entidad?.ruts || [];
    const rutsMalla = entidad?.rutsMalla || [];
    const rutsTodos = [...ruts, ...rutsMalla];
    for(const rut of rutsTodos) {
      rut.filaHabilitada = false;
      const servicios = rut?.servicios || [];
      if(!servicios || servicios.length <= 0) continue;

      for(const servicio of servicios) {
        servicio.actualizarSeleccionado = false;
        servicio.buscarSeleccionado = false;
      }
    }
  }

  showMalla(entidadId: string, rut: string): void {
    if (!this.graphMallaSocietaria || this.graphMallaSocietaria.length <= 0) return;

    const elementsSelected: string[] = []; 
    
    if (this.modeloVista && this.modeloVista.length > 0) {
      for (const entidad of this.modeloVista) {
        const rutsHabilitados = [
          ...entidad?.ruts.filter(r => r?.filaHabilitada),
          ...entidad?.rutsMalla.filter(r => r?.filaHabilitada)
        ];

        for (const rutHab of rutsHabilitados) {
          const nodoGraph = this.graphMallaSocietaria.find(g => g?.entidad === entidad?.idEntidad && g?.rut === rutHab?.rut);
          if (nodoGraph && nodoGraph?.id) {
            elementsSelected.push(nodoGraph.id);
          }
        }
      }
    }

    const nodoFoco = this.graphMallaSocietaria.find(g => g?.entidad === entidadId && g?.rut === rut);

    const dialogRef = this.dialog.open(MallaSocietariaGraphComponent, {
      data: {
        dataOrg: this.graphMallaSocietaria,
        dataOrgPrint: {},
        onFocusId: nodoFoco?.id || '',
        selectedList: elementsSelected
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (resp: any) => {
        if (!resp || Object.keys(resp).length === 0) return;

        for (const entidadKey of Object.keys(resp)) {
          
          this.limpiarEntidad(entidadKey); 

          const seleccionesModal = resp?.[entidadKey] || [];
          if (seleccionesModal.length === 0) continue;

          const entidadModelo = this.modeloVista.find(e => e?.idEntidad === entidadKey);
          if (!entidadModelo) continue;

          for (const elementoSeleccionado of seleccionesModal) {
            
            const nodoGraph = this.graphMallaSocietaria.find(g => g.id === elementoSeleccionado?.id);
            if (!nodoGraph || !nodoGraph.rut) continue;

            const rutTitular = entidadModelo?.ruts.find(r => r?.rut === nodoGraph?.rut);
            if (rutTitular) {
              rutTitular.filaHabilitada = true;
              continue;
            }

            const rutMalla = entidadModelo?.rutsMalla.find(r => r?.rut === nodoGraph?.rut);
            if (rutMalla) {
              rutMalla.filaHabilitada = true;
            }
          }
        }
      },
      error: (error: any) => {
        this.alertService.error(error?.error?.message || 'Ocurrió un Error al procesar la selección del gráfico');
      }
    });
  }

  abrirModal(): void {
    if (!this.entidades || this.entidades.length <= 0) return; // cuando no hay datos arma como minimo la entidad sin ruts
    if (!this.contratoEntidades || this.contratoEntidades.length <= 0) return;

    const dialogRef = this.dialog.open(ModalEntidadesWorkflowComponent, {
      disableClose: true,
      data: {
        entidades: this.entidades,
        contratoEntidades: this.contratoEntidades,
        idTransaccion: this.idTransaccion,
        rut: this.rut
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (resp: any) => {
        if (!resp || Object.keys(resp).length === 0) return;
        const stage5Response = resp?.SolicitudDeCredito?.Stage5Response || null;
        const stage6Response = resp?.SolicitudDeCredito?.Stage6Response || null;
        const stage7Response = resp?.SolicitudDeCredito?.Stage7Response || null;

        this.entidades = stage5Response?.Entidades || [];
        this.contratoEntidades = stage5Response?.Contrato;

        if(stage5Response?.errors?.hasError === true){
          this.alertService.error(stage5Response?.errors?.details?.message || 'Solicitud de Crédito - Ocurrio un error al obtener las entidades');
        }

        if(this.entidades.length > 0 && this.contratoEntidades.length > 0){
          this.getContratoServicios(stage6Response, stage7Response);
        }
      },
      error: (error: any) => {
        console.error(error?.error?.message || 'Ocurrió un Error');
      }
    });
  }

  obtieneFecha(fechaReporte: any): string {
    if(fechaReporte && fechaReporte !== 'Sin Información'){
      if(fechaReporte.includes('T')){
        return fechaReporte;
      } else {
        const fecha1 = fechaReporte.split(' ');
        if(fecha1[0]){
          const fecha2 = fecha1[0].split('-');
          if(fecha2[2]){
            const fecha = new Date(fecha2[2], (Number(fecha2[1]) - 1), fecha2[0]).toISOString();
            return fecha; 
          }
        }
        return ''
      }
    } else {
      return '';
    }
  }

  ordenarPorHabilitado(entidad: EntidadUI, isMalla: boolean): void { 
    // referencia a la lista correcta a ordenar
    const rutsOriginales: RutUI[] = isMalla ? entidad?.rutsMalla : entidad?.ruts;

    if (isMalla) {
      if (entidad?.ordenColumnaMalla === 'habilitado') {
        entidad.ordenAscendenteMalla = !entidad.ordenAscendenteMalla;
      } else {
        entidad.ordenColumnaMalla = 'habilitado';
        entidad.ordenAscendenteMalla = false;
      }
      entidad.paginaMalla = 1; 
    } else {
      if (entidad?.ordenColumnaNormal === 'habilitado') {
        entidad.ordenAscendenteNormal = !entidad.ordenAscendenteNormal;
      } else {
        entidad.ordenColumnaNormal = 'habilitado';
        entidad.ordenAscendenteNormal = false;
      }
      entidad.paginaNormal = 1; 
    }

    const isAscendente = isMalla ? entidad?.ordenAscendenteMalla : entidad?.ordenAscendenteNormal;

    rutsOriginales.sort((a: RutUI, b: RutUI) => {
      const valA = a?.filaHabilitada ? 1 : 0;
      const valB = b?.filaHabilitada ? 1 : 0;

      if (isAscendente) {
        return valA - valB;
      } else {
        return valB - valA;
      }
    });

    this.filtrarRutsBuscador(entidad, isMalla);
  }

  filtrarRutsBuscador(entidad: EntidadUI, isMalla: boolean): void {
    const texto = isMalla ? entidad?.textoBusquedaMalla : entidad?.textoBusquedaNormal;
    const dataReal = isMalla ? entidad?.rutsMalla : entidad?.ruts;

    if (!texto || texto.trim() === '') {
      if (isMalla) entidad.rutsMallaVisibles = [...dataReal];
      else entidad.rutsVisibles = [...dataReal];
      return;
    }

    const search = texto.replace(/[\.\- ]/g, '').toUpperCase();

    const filtrados = dataReal.filter(item => {
      const rutLimpio = item.rut ? item.rut.replace(/[\.\- ]/g, '').toUpperCase() : '';
      return rutLimpio.includes(search);
    });

    // reset
    if (isMalla) {
      entidad.rutsMallaVisibles = filtrados;
      entidad.paginaMalla = 1; 
    } else {
      entidad.rutsVisibles = filtrados;
      entidad.paginaNormal = 1; 
    }
  }

  // Valida si la etapa esta completa y permite avanzar a la siguiente etapa
  avanzarFlujo(): void{
    this.spinner.show();
    this.solicitudCreditoService.obtenerFlujo(this.idTransaccion, this.rut).subscribe(resp => {
      this.bodyModelos = resp;
      if(this.bodyModelos?.stages[7]?.optional === false){
        if(this.bodyModelos?.stages[7]?.completed){
          this.solicitudCreditoService.setStep('next');
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.alertService.error('Solicitud de Crédito - Debe completar la etapa actual para poder avanzar');
        }
      } else {
        this.solicitudCreditoService.setStep('next');
        this.spinner.hide();
      }
    }, (error: any) => {
      this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrio un error al recuperar datos del flujo de credito');
      this.spinner.hide();
    });
  }

}
